import { centerCrop, makeAspectCrop } from 'react-image-crop'

export default (mediaWidth, mediaHeight, aspect = 1) => {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 100,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  )
}
